/**
 * Shared custom vuelidate validations
 */

/**
 * Check date format
 *
 * @param value {string}
 * @returns {boolean}
 */
export function date(value) {
  if(!value) {
    return true
  }

  // Check for some definately invalid chars
  return (/^\d{4}-\d{2}-\d{2}$/).test(value)
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/validators.js
// module id = null
// module chunks = 